export default __webpack_public_path__ + "static/last_year_8-45c2e39753dda388cfc7d6977a9008d2.webp";